import { create } from "zustand";

const nlcInfoStore = create((set, get) => ({
  nlcs: {}, // Lưu trữ tất cả các player và config của họ
  setNlc: (playerId, newValue) => {
    if (newValue == get().nlcs[playerId]) {
      return;
    }
    set((state) => ({
      nlcs: {
        ...state.nlcs,
        [playerId]: newValue
      }
    }))
  }
}));

export default nlcInfoStore;
